import React from "react";
import "./Footer.css";

const serviceLinks = ["Hospital Visits", "Companionship", "Shopping Help", "Walk Assistance"];

const Footer = ({ onServices }) => {
  const openServices = (event) => {
    if (!onServices) {
      return;
    }
    event.preventDefault();
    onServices();
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-brand">
          <h2>EldyCare</h2>
          <p>
            Trusted companionship and support for elders and families. Currently serving Noida.
          </p>
        </div>

        <div className="footer-section">
          <h4>Services</h4>
          {serviceLinks.map((label) => (
            <a key={label} href="#services" onClick={openServices}>
              {label}
            </a>
          ))}
        </div>

        <div className="footer-section">
          <h4>Company</h4>
          <a href="#pricing">Pricing</a>
          <a href="#coverage">Coverage</a>
          <a href="#faq">FAQ</a>
          <a href="#contact">Contact</a>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <a href="mailto:info@eldykare.com">info@eldykare.com</a>
          <a href="mailto:support@eldykare.com">support@eldykare.com</a>
          <a href="tel:+918595729839">8595729839</a>
          <p>Noida, India</p>
        </div>
      </div>

      <div className="footer-bottom">
        © 2026 EldyCare. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
